module.exports = __webpack_public_path__ + "media/logos/logo_finalista_2019-0ac9a0a1.png";